import { useMemo } from 'react';
import { GRPC_WEB_SUPPORT_ENABLED_FLAG } from '@terra/shared-contracts-feature-flags';
import type { HarDisplayConfig } from '@terra/ui-design-system';
import { fetchGrpcHarPreviewDecode } from '../utils/harGrpcDisplay.utils';
import { useFeatureFlags } from './useFeatureFlags';

export const useHarDisplayConfig = (
  applicationId?: string,
): HarDisplayConfig | undefined => {
  const { isFeatureFlagEnabled: protocolDecodeEnabled } = useFeatureFlags(
    GRPC_WEB_SUPPORT_ENABLED_FLAG,
  );

  return useMemo(() => {
    if (!applicationId) {
      return undefined;
    }

    return {
      applicationId,
      protocolDecodeEnabled,
      decodeHarPreview: ({
        applicationId: harApplicationId,
        request,
        response,
      }) =>
        fetchGrpcHarPreviewDecode({
          applicationId: harApplicationId,
          harEntry: { request, response, webGrpcDecodedData: null },
          enabled: protocolDecodeEnabled,
        }),
    };
  }, [applicationId, protocolDecodeEnabled]);
};
